import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaDateTimeNode } from './TypedNode'
import { SchemaDateTimeModel } from './ViewModel'

export const SchemaDateTimePlugin = createSchemaPlugin(
  'Schema.DateTime',
  SchemaDateTimeModel,
  SchemaDateTimeNode
)
